const mockData = {

  orderlist: [
    {
      number: 1,
      items: [{
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      },
      {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }],
    },
    {
      number: 2,
      items: [{
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      },
      {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }],
    },
    {
      number: 3,
      items: [{
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      },
      {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }],
    },
    {
      number: 4,
      items: [{
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      },
      {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }, {
        img: '//img.alicdn.com/tps/TB1FbnzLVXXXXXEapXXXXXXXXXX-60-60.jpg_60x60q90.jpg_.webp',
      }],
    },
  ],

  option: {
    text: 'Sorry I didn\'t get that :(. Please select one of the reasons below:',
    button: [{
      label: 'Change mind',
      value: 'cm',
      action: 'dd',
    }, {
      label: 'Other reason',
      value: 'th',
      action: 'ohter',
    }],
    link: {
      text: 'I don\'t wanto cancel anymore',
    },
  },

  rar: {
    order1: [
      {
        packages: [
          {
            title: 'Package 1, Return to lazada',
            ra_no: '6582342415',
            request_time: 'Apr 23 2019 13:50',
            items: [
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nisi elit fugiat velit culpa occaecat velit eu irure occaecat ullamco ad. Fugiat mollit do nisi laboris mollit non fugiat ex non minim sint veniam sit labore. Ex pariatur labore eu qui esse deserunt dolor irure. Cupidatat nisi nulla excepteur occaecat cupidatat minim culpa id duis ad cillum culpa ullamco.',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind',
                return_amount: '0',
                status: 'Refund Initiated',
                status_note: 'We will contact you to schedule pick up schedule.',
              },
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
            ],
          },
          {
            title: 'Package 2, Refunded',
            ra_no: '6582342415',
            request_time: 'Apr 23 2019 13:50',
            items: [
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
            ],
          },
          {
            title: 'Package 3, Return failed',
            ra_no: '6582342415',
            request_time: 'Apr 23 2019 13:50',
            items: [
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind',
                return_amount: '0',
                status: 'Refund Initiated',
              },
            ],
          },
        ],
      },
    ],
    order2: [
      {
        redirectUrl: 'https://my.lazada.sg/customer/order/index',
        packages: [
          {
            title: 'Package 1, Return to lazada',
            ra_no: '6582342415',
            request_time: 'Apr 23 2019 13:50',
            items: [
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nisi elit fugiat velit culpa occaecat velit eu irure occaecat ullamco ad. Fugiat mollit do nisi laboris mollit non fugiat ex non minim sint veniam sit labore. Ex pariatur labore eu qui esse deserunt dolor irure. Cupidatat nisi nulla excepteur occaecat cupidatat minim culpa id duis ad cillum culpa ullamco.',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind',
                return_amount: '0',
                status: 'Refund Initiated',
                status_note: 'We will contact you to schedule pick up schedule.',
              },
              {
                image: 'https://via.placeholder.com/150',
                title: 'Nike Air Zoom 2018 Urban style Sunnyvale',
                quantity: 2,
                detail: 'Size: CM: 100, Color Family: Blue',
                price: '$75.80',
                original_price: '$89',
                return_reason: 'Change of mind, long copy can grow longer denpends on the input line',
                return_amount: '0',
                status: 'Refunded',
              },
            ],
          },
        ],
      },
    ],
  },
};

export default mockData;



// WEBPACK FOOTER //
// ./src/app/context/channel/robot/mock.js